import type { ReadonlyDeep } from 'type-fest';
import { z } from 'zod';

export const VisionMlModelAttributesSchema = z
  .object({
    mlmodel_name: z.string().optional(),
    camera_name: z.string().optional(),
    default_minimum_confidence: z.number().optional(),
  })
  .passthrough();

export type VisionMlModelAttributes = ReadonlyDeep<
  z.infer<typeof VisionMlModelAttributesSchema>
>;
